// Department Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { departmentConfig } from './departmentConfig';
import { createDepartmentValidation } from './departmentValidation';
// DepartmentService no longer needed - using SWR hooks directly

/**
 * Initialize the department module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  departmentConfig,
  createDepartmentValidation
);

/**
 * Create the DepartmentPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const DepartmentPage = createModulePage(
  initializedConfig,
  {
    displayName: 'DepartmentPage',
    description: 'Department Management System - Manage organizational departments'
  }
);

export default DepartmentPage;
